export const getCustomResultKeys = (): string[] => {
  const resultKeys: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes("ResultSettings")) {
      const stripped = key.replace("ResultSettings", "");
      resultKeys.push(stripped);
    }
  }

  return resultKeys;
};
